import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { isWebMidiSupported } from '../core/midi-support';

@Component({
  selector: 'app-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss'],
  standalone: false,
})
export class UnsupportedBrowserComponent {
  constructor(private router: Router) {}

  /** Re-checks support — useful if the user reopened the app in a compatible browser. */
  retry(): void {
    if (isWebMidiSupported()) {
      this.router.navigateByUrl('/', { replaceUrl: true });
    }
  }
}
